module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"catalog":"Каталог","search_by_oem":"Загрузка списком","login":"Вход","logout":"Выход","phone":"Телефон"},"en":{"catalog":"Catalog","search_by_oem":"Upload by list","login":"Login","logout":"Logout","phone":"Phone"}}')
  delete Component.options._Ctor
}
